import { render, staticRenderFns } from "./LbaLocale.vue?vue&type=template&id=32089208"
import script from "./LbaLocale.vue?vue&type=script&lang=js"
export * from "./LbaLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports